import { useLayoutEffect, useRef, type MutableRefObject } from 'react';

/**
 * A ref that always holds the latest `value`, for a callback that must read current props or state
 * without re-subscribing whenever they change (an event listener, a timer, a stream handler).
 * Updated before paint, so a callback that fires right after a render sees that render's value.
 * The ref itself never changes. react-hooks/exhaustive-deps only knows that of useRef, so list it in a
 * dependency array when the rule asks; doing so changes nothing.
 */
export function useLatest<T>(value: T): MutableRefObject<T> {
    const ref = useRef(value);
    useLayoutEffect(() => {
        ref.current = value;
    });
    return ref;
}
